import { Mesh, Object3D } from "three";

/** Creates a Map from 'globalGroup' to objects */

export function createGlobalGroupReferences(
  rootNode: Object3D,
  globalGroups: Record<string, string[]>,
) {
  const refs: Record<string, Mesh[]> = {};

  Object.keys(globalGroups).forEach((nodeId) => {
    const objectGroups = globalGroups[nodeId];
    const node = rootNode.getObjectByProperty("uuid", nodeId);

    if (node) {
      objectGroups.forEach((groupStr) => {
        if (!refs[groupStr]) refs[groupStr] = [];
        refs[groupStr].push(node as Mesh);
      });
    }
  });

  return refs;
}
